import { ReactNode } from "react";
import { IdentityProvider } from "../contexts/IdentityContext";
import { SocketProvider } from "../contexts/SocketContext";

const DarknetProvider = (props: { children?: ReactNode }) => {
    return (
        <SocketProvider>
            <IdentityProvider>
                {props.children}
            </IdentityProvider>
        </SocketProvider>
    )
}

export default DarknetProvider;